import React, { useEffect, useState } from "react";
import { Modal, Box, Button, Typography, IconButton } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CreditCardDisplay from "../../noc/CreditCardDisplay";
import { useDispatch, useSelector } from "react-redux";
import {
  handlePayment,
  setModalsState,
} from "../../../store/actions/uiActions/myPermitsActions";

const DemoPopPaymentModal = () => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession]?.user);
  const currentPopup = useSelector(
    (state) => state.myPermitsComponent.currentPopup
  );
  const { paymentLoading } = useSelector(
    (state) => state.myPermitsComponent.permits.loadings
  );

  const { paymentModalOpen } = useSelector(
    (state) => state.myPermitsComponent.permits.modalStates
  );

  const [paymentCards, setPaymentCards] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    let cards = [];

    if (currentUser?.payment_cards?.length > 0) {
      cards = currentUser.payment_cards.map((card) => {
        const lastTwo = String(card.exp_year).slice(-2);
        const first = card.exp_month;

        return {
          id: card.id,
          cardNum: "**** **** **** " + card.last4,
          cardName: card.name ? card.name : card.card_holder,
          expires:
            (first < 10 ? "0" + String(first) : String(first)) + "/" + lastTwo,
          default: card.default,
        };
      });

      setPaymentCards(cards);
    }
  }, [currentUser.payment_cards]);

  const title =
    currentPopup === "downloadPayment"
      ? "Purchase Permit Package Download"
      : currentPopup === "vip"
      ? "Purchase VIP Package"
      : currentPopup === "nocPaymentPop"
      ? "Purchase Notice of Commencement Form"
      : "Purchase Permit Package";

  const handleClose = async () =>
    await dispatch(setModalsState({ paymentModalOpen: false }));

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    border: "2px solid #000",
    borderRadius: "20px",
    boxShadow: 24,
    p: 4,
  };

  return (
    <div>
      <Modal
        open={paymentModalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            color="primary"
            id="modal-modal-title"
            align="center"
            variant="h4"
            sx={{ mb: 1 }}
          >
            {title}
          </Typography>
          <Typography align="center" mt={1} mb={3} variant="h6">
            {(paymentCards?.length === 0 || !paymentCards) &&
            currentUser?.subuser?.role !== "Basic User"
              ? "Before proceeding with the payment, please add a credit card"
              : (paymentCards?.length === 0 || !paymentCards) &&
                currentUser?.subuser?.role === "Basic User"
              ? "In order to proceed, you must contact your administrator in order to add a payment card"
              : "Select Payment Card"}
          </Typography>
          {paymentCards?.length === 0 || !paymentCards ? (
            <></>
          ) : (
            <Box sx={{ position: "relative" }}>
              <Box sx={{ cursor: "default" }}>
                <CreditCardDisplay
                  cards={paymentCards}
                  activeStep={activeStep}
                  setActiveStep={setActiveStep}
                />
              </Box>

              <Box
                sx={{
                  position: "absolute",
                  top: "35%",
                  left: 0,
                  display:
                    paymentCards.length === 0 || activeStep === 0
                      ? "none"
                      : undefined,
                }}
              >
                <IconButton
                  onClick={() => {
                    if (activeStep > 0) {
                      setActiveStep(activeStep - 1);
                    }
                  }}
                >
                  <ArrowBackIcon />
                </IconButton>
              </Box>

              <Box
                sx={{
                  position: "absolute",
                  top: "35%",
                  right: 0,
                  display:
                    paymentCards.length - 1 === activeStep ||
                    paymentCards.length === 0
                      ? "none"
                      : undefined,
                }}
              >
                <IconButton
                  onClick={() => {
                    if (paymentCards.length - 1 !== activeStep) {
                      setActiveStep(activeStep + 1);
                    }
                  }}
                >
                  <ArrowForwardIcon />
                </IconButton>
              </Box>
            </Box>
          )}

          <Box
            sx={{
              display: "flex",
              gap: 1,
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Button
              disabled={paymentLoading}
              color="error"
              onClick={handleClose}
              sx={{ mt: 2 }}
            >
              Cancel
            </Button>
            {((paymentCards?.length === 0 || !paymentCards) &&
              currentUser?.subuser?.role !== "Basic User") ||
            paymentCards?.length > 0 ? (
              <LoadingButton
                loading={paymentLoading}
                color="success"
                variant="contained"
                onClick={async () => {
                  if (paymentCards?.length === 0 || !paymentCards) {
                    await dispatch(
                      setModalsState({ addPaymentModalOpen: true })
                    );
                  } else {
                    await dispatch(handlePayment(activeStep));
                  }
                }}
                sx={{ mt: 2 }}
              >
                {(paymentCards?.length === 0 || !paymentCards) &&
                currentUser?.subuser?.role !== "Basic User"
                  ? "Set up Card"
                  : "Proceed"}
              </LoadingButton>
            ) : (
              <></>
            )}
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default React.memo(DemoPopPaymentModal);
